<script setup lang="ts">

import { formatDate } from "@library/Utilities";
import SingleSlicePie from "@app/Components/SingleSlicePie/SingleSlicePie.vue";

type Props =
{
    more?: string,
    expires?: { percent: number, date: Date },
    flip?: boolean
}

const { more, expires, flip = false } = defineProps<Props>();
const hasExpires = expires != null;
const hasMoreLink = more != null;

</script>

<template>

    <div>

        <!-- <ProductLogoOrnament :class="flip ? '-scale-x-100' : ''" /> -->

        <div class="flex items-end justify-between w-full px-4 2xl:px-6 py-3 2xl:py-4 !pt-0">
           
            <div :class="flip ? 'order-1' : 'order-0'">
                <slot>
                </slot>
            </div>

            <div v-if="hasExpires || hasMoreLink"
                 class="absolute right-0 bottom-0 h-3 px-4 2xl:px-6 z-10
                        bg-gray-700 rounded-t-md 2xl:rounded-t-lg">

                <div class="h-4 w-4 bg-gray-700 absolute -left-4 bottom-0">
                    <div class="h-4 w-4 bg-gray-850 rounded-br-[30%]" />
                </div>

                <RouterLink 
                    v-if="more != null"
                    :to="more"
                    class="flex gap-1 items-center uppercase
                           text-xs 2xl:text-sm top-2
                        text-white/60">
                    More
                    <Icon name="chevron-right" />
                </RouterLink>
                
                <div v-else-if="hasExpires && expires != null"
                    class="flex gap-4 items-center text-xs 2xl:text-sm top-2 2xl:top-3">
                    <div class="leading-tight"
                        :class="flip ? 'order-1 left-0.5' : 'order-0 -left-0.5'">
                        <div class="text-gray-400 uppercase">Expires</div>
                        <div class="text-white/80 font-semibold">{{ formatDate( expires.date, 'DD-MMM-YYYY' ) }}</div>
                    </div>
                    <div class="w-5 h-5 2xl:w-6 2xl:h-6 p-0.5 ring ring-white rounded-full">
                        <SingleSlicePie :value="expires.percent" />
                    </div>
                </div>

            </div>

        </div>

        <div class="rounded-tl-lg 2xl:rounded-tl-xl bg-gray-700 h-6 w-full" />

    </div>

</template>